var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("\n\t"+_vm._s(_vm.content)+"\n\t"),_c('MyTooltip',{directives:[{name:"show",rawName:"v-show",value:(_vm.tooltipProps.show),expression:"tooltipProps.show"}],attrs:{"title":_vm.tooltipProps.title,"display-mode":_vm.tooltipProps.displayMode}},[_c('a-icon',{class:_vm.cssClasses,attrs:{"type":_vm.tooltipProps.icon}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }